import { useGlossaryDictionary } from '@/app/[locale]/(learning)/glossary/_component/DictionaryProvider';
import NavigationLink from '@/components/NavigationLink';

export default function DictionaryGrid() {
  const { filteredGroups } = useGlossaryDictionary();

  const list = [];
  for (const entry of filteredGroups) {
    for (const item of entry[1]) {
      list.push(item);
    }
  }

  return (
    <>
      <div className='grid sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 responsive-grid-gap'>
        {list.map((item, index) => (
          <NavigationLink
            key={index}
            href={`/glossary/${item.slug}`}
            className='h5 inline-block px-1 md:px-2 truncate w-[25ch]'
          >
            {item.title}
          </NavigationLink>
        ))}
      </div>
    </>
  );
}
